interface DiffPart {
  text: string;
  highlight: boolean;
}

const normalizeWord = (word: string): string =>
  word
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[.,!?;:"'()-]/g, '');

const shouldSkipHighlight = (oldText: string, newText: string) =>
  ['None', 'No'].includes(oldText) || ['None', 'No'].includes(newText);

const countWords = (words: string[]) =>
  words.reduce((map, w) => {
    const key = normalizeWord(w);
    return { ...map, [key]: (map[key] || 0) + 1 };
  }, {} as Record<string, number>);

export const useDiff = (
  oldText: string,
  newText: string,
  type: 'old' | 'new'
): DiffPart[] => {
  const oldWords = oldText.split(/\s+/).filter(Boolean);
  const newWords = newText.split(/\s+/).filter(Boolean);

  const words = type === 'old' ? oldWords : newWords;
  const skipHighlight = shouldSkipHighlight(oldText, newText);

  const wordsToCompare = type === 'old' ? newWords : oldWords;
  const compareCounts = countWords(wordsToCompare);

  return words.map((word, i) => {
    const normalized = normalizeWord(word);
    const hasMatch = compareCounts[normalized] > 0;

    if (hasMatch) compareCounts[normalized] -= 1;

    return {
      text: i === words.length - 1 ? word : `${word} `,
      highlight: skipHighlight ? false : !hasMatch
    };
  });
};
